export const authorizationRequiredPathPrefix = '/private-asset/'
/** @deprecated Use t('untitled_document_1') with useTranslation instead */
export const defaultDocumentReportTitle = '無名のドキュメント'
export const defaultDocumentReportTitleI18nKey = 'untitled_document_1' as const
